var _linearGradient, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwlactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -0.015,
    x2: 19.465,
    y1: -0.016,
    y2: 20.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0038c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40aeef"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 10,
    width: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#b)",
    height: 20,
    rx: 10,
    width: 20
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M-1 4.542H.75c.362 0 .711.153.957.42l6.362 6.9.793-.86-4.25-4.612h1.75c.361 0 .71.153.956.42l2.705 2.933 2.704-2.934c.246-.266.595-.419.957-.419h1.75l-4.25 4.612.793.86 6.362-6.9c.246-.267.595-.42.957-.42h1.75L17.398 8.5v2.913c0 .971-.413 1.904-1.132 2.557-1.401 1.27-3.606 1.153-4.912-.263l-1.331-1.445-1.33 1.443c-1.306 1.417-3.509 1.536-4.911.263A3.458 3.458 0 0 1 2.65 11.41V8.5zm16.692 5.808-2.446 2.652c.204.086.424.136.648.144l-.002-.002c.472.016.915-.147 1.248-.46.34-.32.536-.751.552-1.22zm-11.336.001 2.443 2.65a1.83 1.83 0 0 1-.647.145 1.712 1.712 0 0 1-1.249-.46 1.732 1.732 0 0 1-.547-1.22v-.056zm5.666 3.632-1.159 1.26 1.159 1.256 1.16-1.257z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlactive);
export default __webpack_public_path__ + "static/media/owl.active.bb48cd4c633731427eda5342531b393d.svg";
export { ForwardRef as ReactComponent };